import { render } from "./CollaboratorDetails.vue?vue&type=template&id=3617874b&scoped=true"
import script from "./CollaboratorDetails.vue?vue&type=script&lang=js"
export * from "./CollaboratorDetails.vue?vue&type=script&lang=js"

import "./CollaboratorDetails.vue?vue&type=style&index=0&id=3617874b&lang=scss&scoped=true"
import "./CollaboratorDetails.vue?vue&type=style&index=1&id=3617874b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3617874b"]])

export default __exports__